import React from "react";
import * as S from "./DimensionsBox.styles";
import { RulerIcon } from "@ubnt/icons";
import { useTranslation } from "hooks/useTranslation";
import { IDimensions } from "./DimensionsBox.types";

export const DimensionsBox = ({
  dimensions,
}: Readonly<{ dimensions: IDimensions[] }>) => {
  const { t } = useTranslation();

  return (
    <S.DimensionsBox>
      <S.DimensionsTitleWrapper>
        <RulerIcon size={32} color="#212124" />
        <S.DimensionsLabel>{t("commons.dimensions")}</S.DimensionsLabel>
      </S.DimensionsTitleWrapper>

      <S.DimensionContentWrapper>
        {dimensions.map((item, index) => (
          <S.Dimensions key={index}>
            {item.label && (
              <S.DimensionsLabel>{t(item.label)}</S.DimensionsLabel>
            )}
            <S.DimensionsItem>{item.dimensionsMillimeters}</S.DimensionsItem>
            <S.DimensionsItem>{item.dimensionsInches}</S.DimensionsItem>
          </S.Dimensions>
        ))}
      </S.DimensionContentWrapper>
    </S.DimensionsBox>
  );
};
